import styled from 'styled-components';

import { BASE } from 'design-system/variables/spacing';

interface SpacerProps {
  height?: number;
  width?: number;
}

/**
 * A simple spacer element used to provide vertical space in grids.
 */
const Spacer = styled.div.attrs(() => ({ 'aria-hidden': true }))<SpacerProps>`
  height: ${({ height = 5 }) => height * BASE}px;
  width: ${({ width = 0 }) => width * BASE}px;
  flex: none;
`;

export default Spacer;
